import { Injectable } from '@angular/core'
import { Router, CanActivate } from '@angular/router'

import { UsersService } from '../services/users.service'

@Injectable()
export class MainGuard implements CanActivate {

  constructor (
    private usersService: UsersService,
    private router: Router) {}

  canActivate (): boolean {
    if ( this.usersService.currentUser.id !== '') return true

    this.router.navigate(['/login'])
    return false
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/guards/main.guard.ts